import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    popUp: false,
    popUpTitle: null,
    popUpText: null,
    redirect: null,
    breadCrumbs: null,
    authorize: false,
    // url: 'http://192.168.4.36', 
    url: 'https://university.unatlib.ru', 
    // url: 'http://localhost:80', 
  },
  getters: {
    POPUP: state => {
      return state.popUp
    },
    POPUPTITLE: state => {
      return state.popUpTitle
    },
    POPUPTEXT: state => {
      return state.popUpText
    },
    REDIRECT: state => {
      return state.redirect
    },
    BREADCRUMBS: state => {
      return state.breadCrumbs
    },
    AUTHORIZE: state => {
      return state.authorize
    },
    URL: state => {
      return state.url
    }
  },
  mutations: {
    popUpWiev: (state, status) => {
      state.popUp = status
    },
    popUpTitleWiev: (state, status) => {
      state.popUpTitle = status
    },
    popUpTextWiev: (state, status) => {
      state.popUpText = status
    },
    reDirect: (state, status) => {
      state.redirect = status
    },
    breadCrumbsSet: (state, status) => {
      state.breadCrumbs = status
    },
    authorize: (state, status) => {
      state.authorize = status
    }
  },
  actions: {
  },
  modules: {
  }
})
